import { alpha, createTheme } from "@mui/material/styles";
import type { Theme } from "@mui/material/styles";
import { Color } from "../lib/color";

export const appTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: Color.color,
      dark: Color.hover,
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#14B8A6",
      contrastText: "#ffffff",
    },
    background: {
      default: "#ffffff",
      paper: "#ffffff",
    },
    text: {
      primary: "#1f2937",
      secondary: "#4b5563",
    },
  },
  shape: {
    borderRadius: 12,
  },
  typography: {
    fontFamily: '"Manrope", "Segoe UI", "Helvetica Neue", Arial, sans-serif',
    h4: {
      fontWeight: 700,
      lineHeight: 1.2,
      fontSize: "1.8rem",
    },
    h6: {
      fontWeight: 600,
      lineHeight: 1.3,
    },
    subtitle2: {
      fontWeight: 500,
      color: "#4b5563",
    },
    body2: {
      fontSize: "0.875rem",
      color: "#4b5563",
    },
    caption: {
      fontSize: "0.75rem",
      color: "#4b5563",
      fontWeight: 500,
    },
    button: {
      textTransform: "none",
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: "0 1px 3px rgba(15, 23, 42, 0.08)",
        },
      },
    },
  },
});

export const pageRootSx = {
  minHeight: "100vh",
  backgroundColor: "background.default",
  p: { xs: 2, md: 3, lg: 4 },
};

export const dashboardRootSx = {
  ...pageRootSx,
  minHeight: "auto",
};

export const surfaceCardSx = {
  backgroundColor: "background.paper",
  p: 3,
  borderRadius: 3,
  border: "1px solid",
  borderColor: "#e9ecef",
  boxShadow: "0 1px 4px rgba(15, 23, 42, 0.06), 0 0 0 1px rgba(15, 23, 42, 0.02)",
};

export const gradientPrimaryButtonSx = (theme: Theme) => ({
  background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
  color: theme.palette.primary.contrastText,
  "&:hover": {
    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
    transform: "translateY(-2px)",
    boxShadow: `0 8px 18px ${alpha(theme.palette.common.black, 0.16)}`,
  },
});

export const filterChipSx = {
  px: 1,
  py: 0.5,
  backgroundColor: "primary.main",
  color: "primary.contrastText",
  borderRadius: 1,
  typography: "caption",
};
